var _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgYoutube(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 1000 1000",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M976.46,260.64c-11.44-42.79-45.13-76.49-87.92-87.92-77.55-20.78-388.54-20.78-388.54-20.78,0,0-310.98,0-388.54,20.78-42.79,11.44-76.49,45.13-87.92,87.92C2.76,338.19,2.76,500,2.76,500c0,0,0,161.81,20.78,239.36,11.44,42.79,45.13,76.48,87.92,87.92,77.55,20.78,388.54,20.78,388.54,20.78,0,0,310.98,0,388.54-20.78,42.79-11.44,76.49-45.14,87.92-87.92,20.78-77.55,20.78-239.36,20.78-239.36,0,0,0-161.81-20.78-239.36ZM400.55,649.17v-298.34l258.36,149.18-258.36,149.17Z"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgYoutube);
export default __webpack_public_path__ + "static/media/youtube.ccaf5ff728be6c9de0ca0875060d592e.svg";
export { ForwardRef as ReactComponent };